<template>
	<div class="header">
		<div style="display: inline-block;" class="gixcore-div">
			<div class="">
			<router-link :to="'/app'"><h3 class="gixcore">Gix<h3 class="gixcore" style="color: #1997c6 !important">Core</h3></h3></router-link>
			</div>
		</div>
		<div style="float: right; margin-right: 8px;" class="links margin-top">
			<div style="display: inline-block;" >
				<router-link :class="{ active: this.$route.fullPath.includes('builder') }" to="/builder">Builder </router-link>
				<span v-if="this.loggedIn == 'false'">
					<router-link :class="{ active: this.$route.name =='Register' }" to="/users/register">Sign Up </router-link>
					<router-link :class="{ active: this.$route.name =='Login' }" to="/users/login">Login</router-link>
				</span>
				<span v-if="this.loggedIn == 'true'">
					<router-link :class="{ active: this.$route.name =='Profile' }"  to="/users/dashboard">Profile</router-link>
				</span>
				<!-- <span v-if="this.loggedIn == 'true'">
					<a href="" v-on:click="logoutLocal()">Logout</a>
				</span> -->
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } 	from 'vuex'

export default {
	name: 'navbar',
	computed: {
		...mapGetters([
			'getToken',
			'lastRoute',
			'loggedIn'
		]),
	},
	methods: {
		...mapActions([
			'retrieveToken',
			'logout',
			'setLoggedIn',
			'setLoggedOut'
		]),
		handleLoginFormSubmit() {
			this.$store.dispatch('login', {
				email: this.email,
				password: this.password
			})
		},
		logoutLocal(){
			this.setLoggedOut()
			this.logout()
		},
	},
	created () {
		if(this.$route.path.includes('register')){
			this.mode = 'register'
		}
		if(this.$route.path.includes('login')){
			this.mode = 'login'
		}
		localStorage.removeItem('new-field')	
    },
	mounted() {
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.navbar {
	min-height: 50px;
	z-index: 1;
}
.active {
	color: #1997c6 !important;
}
.margin-top{
	margin-top: 5px !important;
}
.legend {
	margin-right: 30px;
	display: inline;
}
.links {
	white-space: nowrap;
	margin-left: 3%;
	vertical-align: sub;
}
.links li {
}
.links a {
	font-size: 14px;
	text-transform: uppercase;
	margin-left: 20px;
	color: #B2B3B4;
}
.links a:hover {
	text-decoration: none;
	color: #1997c6;
}
.login-links {

	margin-top: 3px !important;
}
#dropdown-form {
	margin-top: -8px !important;
	margin-right: 60px !important;
	background-color: black !important;
}
.login-field {
	color:#1997c6;
	right: 15px;
	top: 0px;
	position: absolute;
	visibility: hidden;
}
.login-field input{
	margin-top: -8px;
	margin-right: 5px;
	color: white;
	background-color: #434857;
}
.login-field button{
	background-color: transparent;
	border: 1px solid #1997c6;
}
.inline-block {
	display: inline-block;
}
.btn {
	color: #1997c6;
	margin-top: -1px;
	background-color: transparent;
	text-transform: uppercase;
	font-size: 15px;
}
</style>
